<template>
    <div class="about">
        <quick-site-bread-crumb title="Sobre nós"/>
        <!-- ======= 2.02 Page About Area ====== -->

        <div class="aboutArea animated">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-sm-6">
                        <div class="aboutContent">
                            <div class="aboutCell">
                                <h2>Bemvindo  <br>ao Quick-e-Pay.</h2>
                                <div class="aboutTxt">
                                    <p><b>Quick-e-Pay</b> é um producto da empresa Ekutiva Solutions, feita de jovens moçambicanos
                                        inovadores e com uma alta motivação no de sentido a mudança.</p>
                                    <p>O Quick-e-Pay é na verdade um agredador de pagamentos online, muito focado em moeda local
                                        e com um senso de interoperanilidade, isto é, independentemente de qualquer fonte, garantimos
                                        a possibilidade de fazer pagamentos online de serviços, vendas online a retalho, doações e
                                        muito mais.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="aboutImg">
                <img src="../assets/images/about01.jpg" alt="">
            </div>
        </div>

        <!-- ======= /2.02 Page About Area ====== -->

        <!-- ======= 2.03 Page Service Area ====== -->
        <div class="aboutServiceArea secPdng">
            <div class="container animated">
                <div class="row">
                    <div class="col-md-12">
                        <div class="sectionTitle">
                            <div class="h2">
                                Estamos comprometidos com nossos serviços. <br>Oferecemos serviço de excelência.
                            </div>
                        </div>
                    </div>
                </div>


                <!--<div class="row">
                    <div class="col-md-3 col-sm-6">
                        <div class="singleAboutService">
                            <div class="aServiceIcon">
                                <img src="../assets/images/icon/about-server1.png" alt="">
                            </div>
                            <div class="aServiceContent">
                                <div class="aServiceTitle h4">Domain Service</div>
                                <div class="aServiceTxt">
                                    <p>Typi non habent claritatem <br>insitam; est usus legentis.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="singleAboutService">
                            <div class="aServiceIcon">
                                <img src="../assets/images/icon/about-server2.png" alt="">
                            </div>
                            <div class="aServiceContent">
                                <div class="aServiceTitle h4">Domain Service</div>
                                <div class="aServiceTxt">
                                    <p>Typi non habent claritatem <br>insitam; est usus legentis.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="singleAboutService">
                            <div class="aServiceIcon">
                                <img src="../assets/images/icon/about-server3.png" alt="">
                            </div>
                            <div class="aServiceContent">
                                <div class="aServiceTitle h4">Domain Service</div>
                                <div class="aServiceTxt">
                                    <p>Typi non habent claritatem <br>insitam; est usus legentis.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="singleAboutService">
                            <div class="aServiceIcon">
                                <img src="../assets/images/icon/about-server4.png" alt="">
                            </div>
                            <div class="aServiceContent">
                                <div class="aServiceTitle h4">Domain Service</div>
                                <div class="aServiceTxt">
                                    <p>Typi non habent claritatem <br>insitam; est usus legentis.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>-->


            </div>
        </div>
        <!-- ======= /2.03 Page Service Area ====== -->

        <!-- ======= 2.04 Page Team Area ====== -->
        <div class="teamArea secPdng animated">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="sectionTitle">
                            <div class="h2">Uma pequena e grande equipa. <br>Conheça a nossa equipa.</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-6">
                        <div class="singleTeam">
                            <div class="teamImg"><img src="../assets/images/about-team1.jpg" alt=""></div>
                            <div class="teamContent">
                                <div class="memberName h4">Maizer Gomes</div>
                                <span class="position">CEO e Full stack web developer</span>
                                <div class="teamTxt">
                                    <p>Maizer tem uma grande experiência na àrea de densevolvimento e é um dos confundadores da
                                        iniciativa, senão o mentor da ideia.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="singleTeam">
                            <div class="teamImg"><img src="../assets/images/about-team2.jpg" alt=""></div>
                            <div class="teamContent">
                                <div class="memberName h4">Jaime Chizavane</div>
                                <span class="position">COO / SIM e Developer</span>
                                <div class="teamTxt">
                                    <p>Jaime tem uma larga experiência na àrea de gestão de serviços (principalmente na àrea de
                                        serviço financeiros) e é um entusista tecnológico com uma grande paixão por code lines.</p>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </div>
        <!-- ======= /2.04 Page Team Area ====== -->

        <!-- ======= 2.05 Page Newsletters Area ====== -->

        <!-- ======= /2.05 Page Newsletters Area ====== -->
    </div>
</template>
<script>
import QuickSiteBreadCrumb from '../components/site/SiteBreadCrumb'

export default {components: {QuickSiteBreadCrumb}}
</script>



// WEBPACK FOOTER //
// src/views/About.vue